import type { DocEntityType } from "building-types/doc/docEntityTypes";
import { snakeCaseToTitleCase } from "common/utils/strings";

export interface MandatoryReference {
  readonly entityId?: string;
  readonly entityType: DocEntityType;
  readonly entityName: string;
}

/**
 * Formats a list of mandatory references into a human-readable string for
 * error messages.
 */
export function formatMandatoryReferences(refs: readonly MandatoryReference[]): string {
  return refs.map((r) => `${snakeCaseToTitleCase(r.entityType)} '${r.entityName}'`).join(", ");
}

/**
 * Appends a mandatory reference to `refs`, de-duplicating by entity type + id so
 * the same referencing entity is only reported once.
 */
export function pushMandatoryReference(
  refs: MandatoryReference[],
  seenReferenceKeys: Set<string>,
  entityType: DocEntityType,
  entityId: string,
  entityName: string,
): void {
  const key = `${entityType}:${entityId}`;
  if (seenReferenceKeys.has(key)) {
    return;
  }

  seenReferenceKeys.add(key);
  refs.push({ entityType, entityId, entityName });
}
